export class BlroModel {
   public blroId: number;
   public blroName: string;
}


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/blro/blro.model.ts